import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = () => {
    const totalElem = 40
    const height = 35 * (totalElem + 1)
    const body = new Array(totalElem + 1).fill(null).map((i, ind) => {
        const yStrip = ind ? (35 * ind + 15) : 15
        return (
            <React.Fragment key={ind}>
                {
                    <>
                        <rect x='15' y={yStrip} rx='3' ry='3' width='75' height='12' />
                        <rect x='105' y={yStrip - 2} rx='3' ry='3' width='18' height='18' />
                        <rect x='130' y={yStrip - 2} rx='3' ry='3' width='18' height='18' />
                        <rect x='300' y={yStrip} rx='3' ry='3' width='75' height='12' />
                        <rect x='390' y={yStrip - 2} rx='3' ry='3' width='18' height='18' />
                        <rect x='415' y={yStrip - 2} rx='3' ry='3' width='18' height='18' />
                        <rect x='580' y={yStrip} rx='3' ry='3' width='75' height='12' />
                        <rect x='670' y={yStrip - 2} rx='3' ry='3' width='18' height='18' />
                        <rect x='695' y={yStrip - 2} rx='3' ry='3' width='18' height='18' />
                    </>
                }
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={860}
            height={height}
            viewBox={`0 0 860 ${height}`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                {body}
            </>
        </ContentLoader>
    )
}

export default Loader